import React, { Component } from 'react';
import { Table, FormGroup, Label, Input, Button, Collapse } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import authService from '../../services/auth';
import reportService from '../../services/report';
import './UserStatsReport.css';
import './ActiveMenteeReport.css';

const FIRST_YEAR = 2024;
const MENTOR_USER_TYPE_ID = 1;
const MENTEE_USER_TYPE_ID = 2;

class Reports extends Component {
  constructor(props) {
    super(props);
    this.user = authService.getUserFromToken() || {};
    this.years = this.generateYears();
    this.state = {
      menteeYear: this.years[0],
      mentorYear: this.years[0],
      mentees: [],
      mentors: [],
      usersMissingGender: [],
      showMenteeEmailList: false,
      showMentorEmailList: false,
      showMissingGenderEmailList: false,
      isMenteeOpen: true,
      isMentorOpen: true,
      isMissingGenderOpen: true
    };
  }

  generateYears() {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = currentYear; year >= FIRST_YEAR; year--) {
      years.push(year.toString());
    }
    return years.length > 0 ? years : [FIRST_YEAR.toString()];
  }

  async componentDidMount() {
    if (this.user?.userTypeId !== 3) {
      return;
    }
    const [mentees, mentors, usersMissingGender] = await Promise.all([
      reportService.getSignupsByYear(this.state.menteeYear, MENTEE_USER_TYPE_ID),
      reportService.getSignupsByYear(this.state.mentorYear, MENTOR_USER_TYPE_ID),
      reportService.getUsersMissingGender()
    ]);
    this.setState({ mentees, mentors, usersMissingGender });
  }

  handleMenteeYearChange = async (e) => {
    const menteeYear = e.target.value;
    this.setState({ menteeYear, showMenteeEmailList: false });
    const mentees = await reportService.getSignupsByYear(menteeYear, MENTEE_USER_TYPE_ID);
    this.setState({ mentees });
  }

  handleMentorYearChange = async (e) => {
    const mentorYear = e.target.value;
    this.setState({ mentorYear, showMentorEmailList: false });
    const mentors = await reportService.getSignupsByYear(mentorYear, MENTOR_USER_TYPE_ID);
    this.setState({ mentors });
  }

  emailListFor(users) {
    return (users || []).map(u => u.EmailAddress).join(', ');
  }

  renderYearFilter(id, value, onChange) {
    return (
      <FormGroup>
        <Label for={id} style={{ marginRight: '10px', fontWeight: 'bold' }}>Filter by Year:</Label>
        <Input
          type="select"
          name={id}
          id={id}
          value={value}
          onChange={onChange}
          style={{ width: '200px', display: 'inline-block' }}
        >
          {this.years.map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </Input>
      </FormGroup>
    );
  }

  renderSignupList(users, keyPrefix) {
    if (!users || users.length === 0) {
      return <div className="alert alert-success">None!</div>;
    }
    return (
      <Table>
        <thead>
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u, i) => (
            <tr key={`${keyPrefix}-${u.UserId || i}`}>
              <td>{u.FirstName}</td>
              <td>{u.LastName}</td>
              <td>{u.EmailAddress}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }

  renderUsersMissingGenderList(users) {
    if (!users || users.length === 0) {
      return <div className="alert alert-success">None!</div>;
    }
    return (
      <Table>
        <thead>
          <tr>
            <th>Type</th>
            <th>First Name</th>
            <th>Last Name</th>
            <th>Email</th>
          </tr>
        </thead>
        <tbody>
          {users.map((u, i) => (
            <tr key={`missing-gender-${u.UserId || i}`}>
              <td>{u.UserTypeId === MENTOR_USER_TYPE_ID ? 'Mentor' : 'Mentee'}</td>
              <td>{u.FirstName}</td>
              <td>{u.LastName}</td>
              <td>{u.EmailAddress}</td>
            </tr>
          ))}
        </tbody>
      </Table>
    );
  }

  renderSectionHeader(title, count, isOpen, onToggle) {
    return (
      <h3 style={{ fontWeight: 'bold' }}>
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={isOpen}
          style={{
            background: 'none',
            border: 'none',
            padding: 0,
            font: 'inherit',
            color: 'inherit',
            cursor: 'pointer'
          }}
        >
          {isOpen ? '\u25BC' : '\u25B6'} {title} ({count})
        </button>
      </h3>
    );
  }

  renderEmailListExport(users, buttonName, isShown, onClick) {
    return (
      <>
        <Button name={buttonName} onClick={onClick}>Get Email List</Button>
        <br /><br />
        {isShown ? <textarea className="emailListTextArea" readOnly value={this.emailListFor(users)}></textarea> : <div></div>}
      </>
    );
  }

  render() {
    const {
      menteeYear, mentorYear, mentees, mentors, usersMissingGender,
      showMenteeEmailList, showMentorEmailList, showMissingGenderEmailList,
      isMenteeOpen, isMentorOpen, isMissingGenderOpen
    } = this.state;

    return (
      <>
        <div className='pt-5 report-container'>
          {this.renderSectionHeader(
            `Mentor in ${mentorYear}`,
            (mentors || []).length,
            isMentorOpen,
            () => this.setState({ isMentorOpen: !isMentorOpen })
          )}
          <Collapse isOpen={isMentorOpen}>
            {this.renderYearFilter('mentorYearSelect', mentorYear, this.handleMentorYearChange)}
            {this.renderSignupList(mentors, 'mentor-signup')}
            {this.renderEmailListExport(
              mentors,
              'btnExportMentorEmailList',
              showMentorEmailList,
              () => this.setState({ showMentorEmailList: true })
            )}
          </Collapse>
        </div>

        <div className='report-container'>
          {this.renderSectionHeader(
            `Mentee in ${menteeYear}`,
            (mentees || []).length,
            isMenteeOpen,
            () => this.setState({ isMenteeOpen: !isMenteeOpen })
          )}
          <Collapse isOpen={isMenteeOpen}>
            {this.renderYearFilter('menteeYearSelect', menteeYear, this.handleMenteeYearChange)}
            {this.renderSignupList(mentees, 'mentee-signup')}
            {this.renderEmailListExport(
              mentees,
              'btnExportMenteeEmailList',
              showMenteeEmailList,
              () => this.setState({ showMenteeEmailList: true })
            )}
          </Collapse>
        </div>

        <div className='report-container'>
          {this.renderSectionHeader(
            'Users Missing Gender',
            (usersMissingGender || []).length,
            isMissingGenderOpen,
            () => this.setState({ isMissingGenderOpen: !isMissingGenderOpen })
          )}
          <Collapse isOpen={isMissingGenderOpen}>
            {this.renderUsersMissingGenderList(usersMissingGender)}
            {this.renderEmailListExport(
              usersMissingGender,
              'btnExportMissingGenderEmailList',
              showMissingGenderEmailList,
              () => this.setState({ showMissingGenderEmailList: true })
            )}
          </Collapse>
        </div>
      </>
    );
  }
}

export default withRouter(Reports);
